<template>
  <div class="detail_information">
    <Flow v-bind:step="4"/>
    <Shipping
      @deliveryAddressData="getDeliveryAddressData"
      @availableBulkSetting="getAvailableBulkSetting"
      :deliveryDateList="deliveryDateList"
      :deliveryTimeList="deliveryTimeList"
      :initialDeliveryDateValue="detailData.deliveryDate.deliveryDateValue"
      :initialDeliveryTimeValue="detailData.deliveryTimeData.deliveryTimeId"
      @update-date="updateDeliveryDate"
      @update-time="updateDeliveryTime"
    />
    <div class="products_wrap bg_white mt12 pt16 pb16">
      <h2 class="content_title">お支払い方法</h2>
      <div class="payment_wrap mt24 c5a">
        <div v-for="(index, n) in paymentMethodList" class="payment_item bdb pl16 pr20 pb10" v-bind:class="{'pt19': n != 0}" :key="n">
          <div class="" :class="{ disable: detailData.paymentData.paymentMethod == 'WALLET'}">
            <input :id="'payment' + n" class="payment_radio" type="radio" name="payment" :checked="detailData.paymentData.paymentMethod == index.paymentMethod">
            <label :for="'payment' + n" class="payment_contents rb" v-on:click="selectPayment(index)">{{ index.paymentMethodName }}</label>
          </div>
          <div v-if="index.paymentMethod == 'CREDIT_CARD'" class="credit_label" v-bind:class="{'select': detailData.paymentData.paymentMethod == 'CREDIT_CARD'}">
            <div v-if="detailData.selectCreditData.cardNo">
              <span class="credit_number rr">
                {{ detailData.selectCreditData.cardNo }}
              </span>
              <div class="mt30">
                <h3 class="rb c5a">お支払回数</h3>
                <select class="mt10 split_payment" name="split_payment_count" @change="selectSplitPayment($event.target.value)">
                  <option
                    v-for="splitCount in index.paymentCountList"
                    :value="splitCount.value"
                    :selected="splitCount.value == detailData.paymentData.paymentCount"
                    :key="splitCount.value"
                  >
                    {{ splitCount.label }}
                  </option>
                </select>
                <span class="bottom_arrow split_arrow"/>
              </div>
            </div>
            <span v-else class="credit_number rr">クレジットカードが登録されていません</span>
          </div>
        </div>
        <div v-if="detailData.paymentData.paymentMethod == 'WALLET'" class="pl16 pt19 pr16 ab c5a">全額ウォレットで支払います</div>
      </div>

    </div>

    <!-- クレジット情報変更画面 -->
    <SelectCredit ref="openCreditSelect" v-bind:pageName="this.purchase" @close="closeCredit" @selectData="sendCredit" />
    <ErrorModal v-show="isModalOpen" :errorMessage="errorMessage" @modalClose="modalClose" />
    <div class="products_wrap bg_white mt12 pt32 pb48">
      <a href="#" class="btn_blue" @click.stop.prevent="nextBtn()">次へ</a>
      <!-- <router-link class="btn_blue" :to="{ name: 'Confirm', params: { detailData: detailData } }" v-on:click.native="nextBtn()">次へ</router-link> -->
      <router-link class="btn_delete back_btn" :to="{ name: 'PurchaseDiscount' }">戻る</router-link>
    </div>

  </div>
</template>

<script>
import Flow from '@/components/purchase/Flow'
import SelectCredit from '@/components/common/SelectCredit'
import Shipping from '@/components/purchase/Shipping'
import Bank from '@/components/api/bank'
import Purchases from '@/components/api/purchases'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';
import ErrorModal from '@/components/common/ErrorModal'
import PurchaseModel from '@/model/purchase/purchaseWallet';
import CreditcardExpired from '@/components/common/CreditcardExpired.vue';
import PurchaseWallet from '@/components/api/purchase/purchaseWallet';

export default {
  components: {
    Flow,
    SelectCredit,
    Shipping,
    ErrorModal,
    CreditcardExpired,
  },
  data() {
    return {
      isModalOpen: false,
      errorMessage: '未選択の項目があります。',
      selectCreditOpen: false,
      purchase: 'purchase',
      paymentMethodList: [],
      detailData: {
        deliveryDate: {
          deliveryDateLabel: "",
          deliveryDateValue: "",
        },
        deliveryTimeData: {
          deliveryTimeId: 0,
          deliveryTimeName: '',
        },
        deliveryAddressData: {
          recipientName: '',
          deliveryAddressId: 0,
          zipCode: '',
          prefectureName: '',
          address: ''
        },
        paymentData: {
          paymentMethod: '',
          paymentMethodName: '',
          paymentCount: 1,
        },
        selectCreditData: {
          cardBrand: '',
          cardNo: '',
          creditCardId: 0,
          expireYearMonth: null,
          expired: false,
          holderName: '',
          selected: false
        },
        availableBulkSetting: false,
      },
      deliveryDateTimeList: [],
      deliveryDateList: [],
      deliveryTimeList: [],
    }
  },
  methods: {
    getDeliveryAddressData(data) {
      this.detailData.deliveryAddressData.recipientName = data.recipientName;
      this.detailData.deliveryAddressData.deliveryAddressId = data.deliveryAddressId;
      this.detailData.deliveryAddressData.zipCode = data.zipCode;
      this.detailData.deliveryAddressData.prefectureName = data.prefectureName;
      this.detailData.deliveryAddressData.address = data.address;
    },
    getAvailableBulkSetting(data) {
      this.detailData.availableBulkSetting = data.availableBulkSetting;
    },
    selectPayment(data) {
      if(this.detailData.paymentData.paymentMethod == 'WALLET') return;
      this.detailData.paymentData.paymentMethod = data.paymentMethod;
      this.detailData.paymentData.paymentMethodName = data.paymentMethodName;
      if(this.detailData.paymentData.paymentMethod == 'CREDIT_CARD') {
        this.detailData.paymentData.expireYearMonth = data.expireYearMonth;
        this.detailData.paymentData.expired = data.expired;
        this.storeActionsPaymentCreditcardData();
      }

      this.storeActionsPaymentData();
    },
    selectCredit() {
      scrollPosition.open();
      // SelectCreditコンポーネントの関数実行
      this.$refs.openCreditSelect.refsOpen();
    },
    closeCredit() {
      this.credit.open = false;
    },
    sendCredit(data) {
        this.detailData.selectCreditData.cardBrand =  data.cardBrand;
        this.detailData.selectCreditData.cardNo =  data.cardNo;
        this.detailData.selectCreditData.creditCardId =  data.creditCardId;
        this.detailData.selectCreditData.expireYearMonth =  data.expireYearMonth;
        this.detailData.selectCreditData.expired =  data.expired;
        this.detailData.selectCreditData.holderName =  data.holderName;
        this.detailData.selectCreditData.selected =  data.selected;

        // userDetailストアにクレジット情報を反映
        this.$store.dispatch('commitUserDetailCreditData', {
            cardBrand: data.cardBrand,
            cardNo: data.cardNo,
            creditCardId: data.creditCardId,
            expireYearMonth: data.expireYearMonth,
            expired: data.expired,
            holderName: data.holderName,
            selected: data.selected,
            sameWithBc001: false
        });
    },
    modalOpen() {
      this.isModalOpen = true;
    },
    modalClose() {
      this.isModalOpen = false;
    },
    // クレカの分割払い回数の選択時に発火する関数
    selectSplitPayment(data) {
      const dataChangeInt = Number(data)
      this.$store.commit('setUserDetailPaymentDataSelectPaymentCount', dataChangeInt );
      this.changePaymentCount();
    },
    // 分割回数のstoreデータをコンポーネントのデータに反映させる
    changePaymentCount() {
      this.detailData.paymentData.paymentCount = this.$store.state.userDetail.paymentData.selectPaymentCount;
    },
    nextBtn() {
      if(this.detailData.deliveryAddressData.deliveryAddressId == '') {
        this.errorMessage = '配送住所を選択してください';
        this.modalOpen();
        return false;
      }
      if(this.detailData.paymentData.paymentMethod == '') {
        this.errorMessage = 'お支払い方法を選択してください。';
        this.modalOpen();
        return false;
      } else if(this.detailData.paymentData.paymentMethod == 'CREDIT_CARD') {
        if(this.detailData.selectCreditData.creditCardId == '') {
          this.errorMessage = 'クレジットカードを選択してください。';
          this.modalOpen();
          return false;
        }
      }

      // ローカルストレージ保存前にdetailDataの内容をuserDetailに同期
      this.syncDetailDataToUserDetail();
      localStorage.setItem('userDetail', JSON.stringify(this.userDetail));
      this.$router.push({ name: 'Confirm', params: {detailData: this.detailData}});
    },
    storageData() {
      this.apiGetPaymentMethodList();
    },
    storeActionsPaymentData() {
      this.$store.dispatch('commitUserDetailPaymentData', { paymentMethodId: '', paymentMethodName: this.detailData.paymentData.paymentMethodName, paymentMethod: this.detailData.paymentData.paymentMethod });
    },
    storeActionsPaymentCreditcardData() {
      this.$store.dispatch('commitUserDetailPaymentData', { expireYearMonth: this.detailData.paymentData.expireYearMonth, expired: this.detailData.paymentData.expired});
    },
    async apiGetPaymentMethodList () {
      await Purchases.getPaymentMethodList().then((val) => {
        this.paymentMethodList.push(...val);
        this.detailData.paymentData.paymentCount = this.$store.state.userDetail.paymentData.selectPaymentCount;

        let data = PurchaseModel.purchaseOrderList(this.purchaseWalletBcShipmentFeeList);
        let totalPrice = PurchaseModel.calcTotalPrice(data);
        // ウォレット使用後の請求金額が0の場合
        if(this.purchaseWalletUseWalletBillAmount == 0 || this.purchaseWalletUseWalletBillAmount < 0) {
          this.detailData.paymentData.paymentMethod = 'WALLET';
          this.detailData.paymentData.paymentMethodName = '全額ウォレット支払い'
        } else {
          let userDetail = JSON.parse(localStorage.getItem('userDetail'));
          if(userDetail) {
            let findItem = this.paymentMethodList.findIndex((value) => value.paymentMethod == userDetail.paymentData.paymentMethod);
            if(findItem != -1) {
              this.detailData.paymentData.paymentMethod = userDetail.paymentData.paymentMethod;
              this.detailData.paymentData.paymentMethodName = userDetail.paymentData.paymentMethodName;
              this.detailData.paymentData.paymentCount = userDetail.paymentData.selectPaymentCount;
            } else {
              this.detailData.paymentData.paymentMethod = val[0].paymentMethod;
              this.detailData.paymentData.paymentMethodName = val[0].paymentMethodName;
            }
          } else {
            this.detailData.paymentData.paymentMethod = val[0].paymentMethod;
            this.detailData.paymentData.paymentMethodName = val[0].paymentMethodName;
          }
        }

        this.storeActionsPaymentData();
      });
    },
    async apiGetDeliveryDateTimeList() {
      const data = PurchaseModel.requestData(this.detailData, this.purchaseWalletUseBirthMonthDiscount, this.purchaseWalletWalletAmount, this.userDetailCouponList, this.purchaseWalletBcShipmentFeeList);
      await PurchaseWallet.getDeliveryDateTimeList(data).then((val) => {
        this.deliveryDateTimeList = val;
        this.deliveryDateTimeList.forEach((value) => {
          this.deliveryDateList.push({
            deliveryDateLabel: value.deliveryDateLabel,
            deliveryDateValue: value.deliveryDateValue
          });
        });
        this.setInitialDeliveryData();

      });
    },
    updateDeliveryDate(newDate) {
      console.log('updateDeliveryDate newDate', newDate);
      // this.detailData.deliveryDate = newDate;
      let findDeliveryDateItem = this.deliveryDateTimeList.find((value) => value.deliveryDateValue === newDate);
      console.log('findDeliveryDateItem', findDeliveryDateItem);
      this.detailData.deliveryDate.deliveryDateLabel = findDeliveryDateItem.deliveryDateLabel;
      this.detailData.deliveryDate.deliveryDateValue = findDeliveryDateItem.deliveryDateValue;
      this.$store.commit('setUserDetailDeliveryDateValue', this.detailData.deliveryDate.deliveryDateValue);
      this.$store.commit('setUserDetailDeliveryDateLabel', this.detailData.deliveryDate.deliveryDateLabel);
      let findItem = this.deliveryDateTimeList.find((value) => value.deliveryDateValue === newDate);
      if (!findItem || findItem == -1) return;
      this.deliveryTimeList = findItem.deliveryTimeList;
    },
    updateDeliveryTime(newTimeId) {
      let newTimeData = this.deliveryTimeList.find((value) => value.deliveryTimeId == newTimeId);
      if (!newTimeData || newTimeData == undefined) return;
      console.log('newTimeData', newTimeData);
      this.detailData.deliveryTimeData.deliveryTimeId = newTimeData.deliveryTimeId;
      this.detailData.deliveryTimeData.deliveryTimeName = newTimeData.deliveryTimeName;
      this.$store.dispatch('commitUserDetailDeliveryTimeData', { deliveryTimeId: this.detailData.deliveryTimeData.deliveryTimeId, deliveryTimeName: this.detailData.deliveryTimeData.deliveryTimeName });
    },
    setInitialDeliveryData() {
      const userDetail = JSON.parse(localStorage.getItem('userDetail'));

      if (userDetail) {
        this.detailData.deliveryDate.deliveryDateValue = userDetail.deliveryDate.deliveryDateValue;
        this.detailData.deliveryDate.deliveryDateLabel = userDetail.deliveryDate.deliveryDateLabel;
        this.detailData.deliveryTimeData.deliveryTimeId = userDetail.deliveryTimeData.deliveryTimeId;
        this.detailData.deliveryTimeData.deliveryTimeName = userDetail.deliveryTimeData.deliveryTimeName;
      } else {
        this.detailData.deliveryDate.deliveryDateValue = this.deliveryDateList[0].deliveryDateValue;
        this.detailData.deliveryDate.deliveryDateLabel = this.deliveryDateList[0].deliveryDateLabel;
        this.detailData.deliveryTimeData.deliveryTimeId = this.deliveryDateTimeList[0].deliveryTimeList[0].deliveryTimeId;
        this.detailData.deliveryTimeData.deliveryTimeName = this.deliveryDateTimeList[0].deliveryTimeList[0].deliveryTimeName;
      }

      this.updateDeliveryDate(this.detailData.deliveryDate);
      console.log('this.detailData.deliveryTimeData.deliveryTimeId', this.detailData.deliveryTimeData.deliveryTimeId);
      this.updateDeliveryTime(this.detailData.deliveryTimeData.deliveryTimeId);
    },
    // detailDataの内容をuserDetailストアに同期するメソッド
    syncDetailDataToUserDetail() {
      // 配送日時情報の同期
      this.$store.commit('setUserDetailDeliveryDateValue', this.detailData.deliveryDate.deliveryDateValue);
      this.$store.commit('setUserDetailDeliveryDateLabel', this.detailData.deliveryDate.deliveryDateLabel);
      this.$store.dispatch('commitUserDetailDeliveryTimeData', {
        deliveryTimeId: this.detailData.deliveryTimeData.deliveryTimeId,
        deliveryTimeName: this.detailData.deliveryTimeData.deliveryTimeName
      });

      // 住所情報の同期
      this.$store.dispatch('commitUserDetailDeliveryAddressData', {
        recipientName: this.detailData.deliveryAddressData.recipientName,
        deliveryAddressId: this.detailData.deliveryAddressData.deliveryAddressId,
        zipCode: this.detailData.deliveryAddressData.zipCode,
        prefectureName: this.detailData.deliveryAddressData.prefectureName,
        address: this.detailData.deliveryAddressData.address,
        sameWithBc001: this.detailData.deliveryAddressData.sameWithBc001 || false
      });

      // 支払い情報の同期
      this.$store.dispatch('commitUserDetailPaymentData', {
        paymentMethodId: this.detailData.paymentData.paymentMethodId || '',
        paymentMethodName: this.detailData.paymentData.paymentMethodName,
        paymentMethod: this.detailData.paymentData.paymentMethod
      });

      // 分割払い回数の同期
      this.$store.commit('setUserDetailPaymentDataSelectPaymentCount', this.detailData.paymentData.paymentCount);

      // クレジット情報の同期（クレジットカード選択時のみ）
      if(this.detailData.selectCreditData.creditCardId) {
        this.$store.dispatch('commitUserDetailCreditData', {
          cardBrand: this.detailData.selectCreditData.cardBrand,
          cardNo: this.detailData.selectCreditData.cardNo,
          creditCardId: this.detailData.selectCreditData.creditCardId,
          expireYearMonth: this.detailData.selectCreditData.expireYearMonth,
          expired: this.detailData.selectCreditData.expired,
          holderName: this.detailData.selectCreditData.holderName,
          selected: this.detailData.selectCreditData.selected,
          sameWithBc001: this.detailData.selectCreditData.sameWithBc001 || false
        });
      }

      // その他設定の同期
      this.$store.commit('setUserDetailAvailableBulkSetting', this.detailData.availableBulkSetting);
    },
  },
  computed: mapGetters([
    'userDetail',
    'purchaseWalletWalletAmount',
    'userDetailCouponList',
    'purchaseWalletBcShipmentFeeList',
    'purchaseWalletBirthMonthDiscountPrice',
    'purchaseWalletShipmentFee',
    'purchaseWalletUseWalletBillAmount'
  ]),
  created () {
    this.storageData();
    this.detailData.availableBulkSetting = this.$store.state.userDetail.availableBulkSetting;
    this.apiGetDeliveryDateTimeList();
  },
}
</script>

<style lang="css" scoped>
.content_title {
  width: 123px;
}
.shipping_time, .coupon_select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.shipping_time {
  border: none;
  font-size: 16px;
  position: relative;
  width: 100%;
  z-index: 1;
}

.detail_information .address {
  font-size: 14px;
  margin-top: 3px;
}
.address_text {
  margin-left: 8px;
}

.credit_number {
  display: block;
  font-size: 14px;
}

.credit_label {
  display: none;
  margin-top: 15px;
  padding-left: 28px;
}

.credit_label.select {
  display: block;
}

.no_coupon {
  margin-bottom: 24px;
  padding-bottom: 5px;
}

.coupon_title {
  border-left: 4px solid  #4FCCD4;
  font-size: 16px;
  padding-left: 4px;
}

.coupon_item {
  align-items: flex-end;
  display: flex;
  margin-top: 27px;
}
.possession_coupon {
  display: flex;
  width: 68%;
}

.possession_count, .can_count {
  font-size: 12px;
}
.possession_count--number, .can_count--number {
  font-size: 18px;
  margin-left: 9px;
}

.can_count {
  margin-left: 26px;
}

.use_wrap {
  align-items: center;
  display: flex;
  margin-left: 8px;
  width: 30%;
}
.use_text {
  font-size: 12px;
  min-width: 40px;
}

.coupon_select--wrap {
  width: 60%;
}

.coupon_select {
  border: none;
  border-bottom: 1px solid  #5a5a5a;
  font-size: 26px;
  padding-left: 15px;
  width: 100%;
}



.coupon_select--wrap.bottom_arrow::after {
  bottom: 7px;
  right: 2px;
}

.select_wrap.bottom_arrow::after {
  bottom: 7px;
  right: 22px;
}

.payment_item .right_arrow::after {
  right: 5px;
}

.disable {
  position: relative;
}
.disable::before {
  background-color: #aaa;
  content: '';
  height: 100%;
  left: 0;
  opacity: .5;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 4;
}
.split_payment {
  width: 100%;
  font-size: medium;
  color: black;
}
.split_arrow {
  right: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/purchase/DetailInformation.vue